/**
 * @property {string} path - router path that is to be redirected
 * @property {string} redirectUrl - internal path or external url to which the redirect should go
 * @property {boolean} isAbsolute - whether the `redirectUrl` is an absolute external url
 * @property {boolean} keepQuery - whether the query string should be appended to the redirect url
 * @property {boolean} keepHash - whether the hash string should be appended to the redirect url
 */
export class Redirect {
  /**
   * @param {string} path
   * @param {string} redirectUrl
   * @param {boolean} isAbsolute
   * @param {boolean} keepQuery
   * @param {boolean} keepHash
   */
  constructor({ path, redirectUrl, isAbsolute = false, keepQuery = true, keepHash = true }) {
    this.path = path;
    this.redirectUrl = redirectUrl;
    this.isAbsolute = isAbsolute;
    this.keepQuery = keepQuery;
    this.keepHash = keepHash;
  }
}
